/**
 * Checks whether `data` is included in `positions` based on
 * `key`, `articleNumber`, or `name`, in that order.
 *
 * @param {Object[]} positions  the positions in the cart
 * @param {Object} data         the incoming data
 * @returns {Object|false}
 */
export const findPosition = (positions, data) => positions.find(
  position => (position?.key && data?.key ? position.key === data.key : undefined)
    ?? (position?.articleNumber && data?.articleNumber ? position.articleNumber === data.articleNumber : undefined)
    ?? (position?.name === data?.name),
)
